import React from 'react'

import { get } from 'lodash'
import PropTypes from 'prop-types'

import fieldMapper from '../../util/fieldMapper'

const CustomFieldRender = ({ field, value, setFieldValue, ...props }) => {
  const components = {
    inputText: require('../CustomInput/customInput').default,
    inputNumber: require('../CustomInput/customInput').default,
    inputArea: require('../CustomInput/customInput').default,
    date: require('../CustomInput/customInput').default,
    select: require('../CustomSelect/customSelect').default,
    selectTable: require('../CustomSelect/customSelect').default,
    upload: require('../CustomUpload').default,
    selectMultiple: require('../CustomSelect/customSelectMultiple').default,
    selectOrder: require('../CustomInputTable/custominputtable').default,
    message: require('../CustomInput/customInput').default,
    inputLocation: require('../CustomLocation/customLocation').default
  }
  const componentType = get(field, 'fieldTypes.internalTypeName', 'inputText')
  const {
    type = 'text',
    component = 'inputText',
    maxlenght,
    minlenght,
    max,
    min,
    options,
    mask,
    required,
    dateFormat,
    error,
    values,
    multiple = false
  } = fieldMapper(componentType, field)

  const CustomComponent = components[component]

  const fieldName = get(field, 'fieldName', '')
  const name = get(field, 'internalFieldName', '')
  const customFormId = `customFormId_${get(field, 'formId', '')}`
  const errors = { [name]: error }
  const fieldProperties =
    typeof field.fieldProperties == 'string' ? JSON.parse(field.fieldProperties) : field.fieldProperties //JSON.parse(field.fieldProperties)
  const placeholder = get(fieldProperties, 'placeholder', '')
  const selectValues = get(fieldProperties, 'options', [])
  const extensions = get(fieldProperties, 'extensions')

  return (
    <CustomComponent
      customFormId={customFormId}
      name={name}
      id={name}
      field={fieldName}
      type={type}
      placeholder={placeholder || null}
      maxlenght={maxlenght || null}
      minlenght={minlenght || null}
      value={value}
      values={selectValues.length > 0 ? selectValues : values}
      error={error}
      handleRemove={props.handleRemove}
      mask={mask}
      options={options}
      errors={errors}
      setFieldValue={setFieldValue}
      multiple={multiple}
      textArea={component === 'inputArea'}
      max={max || null}
      min={min || null}
      required={required}
      dateFormat={dateFormat}
      extensions={extensions}
      fieldProperties={fieldProperties}
      {...props}
    />
  )
}

CustomFieldRender.propTypes = {
  field: PropTypes.object.isRequired
}

export default CustomFieldRender
